<ion-fab-button [disabled]="disabled || waiting"
                [class.selected]="selected"
                [ngClass]="[customClassName, size]"
                [type]="type">
    <ng-container *ngIf="!waiting; else spinner">
        <i *ngIf="icon" [class]="icon" [class.selected]="selected"></i>
        <ion-icon [name]="ionIcon" *ngIf="ionIcon" [class.selected]="selected"></ion-icon>
    </ng-container>
</ion-fab-button>

<ng-template #spinner>
    <ion-spinner></ion-spinner>
</ng-template>
